module.exports = __webpack_public_path__ + "static/fonts/Inter-Bold.91e5aee8.ttf";